import { render, staticRenderFns } from "./OutdatedError.vue?vue&type=template&id=3b324339&scoped=true&lang=pug&"
import script from "./OutdatedError.vue?vue&type=script&lang=js&"
export * from "./OutdatedError.vue?vue&type=script&lang=js&"
import style0 from "./OutdatedError.vue?vue&type=style&index=0&id=3b324339&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b324339",
  null
  
)

export default component.exports